/**
 * 获取首图
 *
 * @param images 图片信息或图片信息列表
 */
export function getFirstImage(images, defaultImage) {
  var first = (Array.isArray(images) ? images : [images])[0];
  var image = first ? first.video ? first.poster : first.url : undefined;
  return image || defaultImage;
}